import { isShortFormCountry } from "./isShortFormCountry";

/**
 * Decides whether a logged-in user should be treated as having completed
 * a simplified registration — i.e. they should NOT be pushed into the
 * /incomplete flow to fill passport / nationality / birthdate.
 *
 * Two signals are considered, in order:
 *
 * 1. Persisted flag (`additionalFields.simple_registration` or the
 *    legacy `additionalFields.isSimpleRegistration`). This is what
 *    AuthFormRegister writes at registration time when the user goes
 *    through the shortForm flow. `additionalFields` may arrive as a
 *    JSON-encoded string from the backend; malformed JSON is treated
 *    as "no flag" and never throws.
 *
 * 2. Fallback by country (SQD-412): legacy users from the shortForm
 *    countries that registered before the persisted flag existed
 *    should still be treated as simple registration based on their
 *    persisted ddi / nationality.
 */
export function resolveIsSimpleRegistration(user) {
    const data = user && user.data;
    if (!data) return false;

    let additional = data.additionalFields;
    if (typeof additional === "string") {
        try {
            additional = JSON.parse(additional);
        } catch (e) {
            additional = null;
        }
    }

    const hasPersistedFlag = !!(
        additional &&
        (additional.isSimpleRegistration || additional.simple_registration)
    );
    if (hasPersistedFlag) return true;

    return isShortFormCountry({
        ddi: data.ddi,
        nationality: data.nationality,
    });
}
